import { createSelector } from 'reselect';

const selectDbaasSubscriptions = (state: any) => state.dbaasSubscriptions;


export const selectDbaasSubscriptionsCurrentItem = createSelector([selectDbaasSubscriptions], (dbaasSubscriptions) => dbaasSubscriptions.current);

export const selectDbaasSubscriptionsListItems = createSelector([selectDbaasSubscriptions], (dbaasSubscriptions) => dbaasSubscriptions.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectDbaasSubscriptionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDbaasSubscriptionsQueryItems = createSelector([selectDbaasSubscriptions], (dbaasSubscriptions) => dbaasSubscriptions.query);

export const selectDbaasSubscriptionsCreatedItem = createSelector([selectDbaasSubscriptions], (dbaasSubscriptions) => dbaasSubscriptions.create);

export const selectDbaasSubscriptionsUpdatedItem = createSelector([selectDbaasSubscriptions], (dbaasSubscriptions) => dbaasSubscriptions.update);

export const selectDbaasSubscriptionsReadItem = createSelector([selectDbaasSubscriptions], (dbaasSubscriptions) => dbaasSubscriptions.read);

export const selectDbaasSubscriptionsDeletedItem = createSelector([selectDbaasSubscriptions], (dbaasSubscriptions) => dbaasSubscriptions.delete);

export const selectDbaasSubscriptionsSearchedItems = createSelector([selectDbaasSubscriptions], (dbaasSubscriptions) => dbaasSubscriptions.search);

export const selectDbaasSubscriptionsItemsCount = createSelector([selectDbaasSubscriptions], (dbaasSubscriptions) => dbaasSubscriptions.count);

export const selectDbaasSubscriptionsItemsFilter = createSelector([selectDbaasSubscriptions], (dbaasSubscriptions) => dbaasSubscriptions.filter);